<template>
  <div>
    <NavBar />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 32 32"
              style="enable-background: new 0 0 32 32"
              xml:space="preserve"
            >
              <path
                d="M28,7V3H0v22c0,0,0,4,4,4h25c0,0,3-0.062,3-4V7H28z M4,27c-2,0-2-2-2-2V5h24v20 c0,0.921,0.284,1.559,0.676,2H4z"
              ></path>
              <rect x="4" y="9" width="20" height="2"></rect>
              <rect x="15" y="21" width="7" height="2"></rect>
              <rect x="15" y="17" width="9" height="2"></rect>
              <rect x="15" y="13" width="9" height="2"></rect>
              <rect x="4" y="13" width="9" height="10"></rect>
            </svg>
            Avisos
          </h1>
          <ul class="tabs">
            <li>
              <router-link to="/noticias">Avisos</router-link>
            </li>
            <li class="tab-active">
              <router-link :to="this.item._id"
                >Aviso: {{ this.item.titulo }}</router-link
              >
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <div class="form">
                <div class="row">
                  <div class="col-2-3">
                    <div class="form-group">
                      <label for>Título</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="item.titulo"
                        @keyup="changeSomething()"
                      />
                    </div>
                  </div>
                  <div class="col-1-3">
                    <div class="form-group">
                      <label for>Público Alvo</label>
                      <select
                        v-model="item.publico"
                        class="form-control"
                        @change="changeSomething()"
                      >
                        <option value>Selecione</option>
                        <option value="publico">Público</option>
                        <option value="callcenter">Call Center</option>
                        <option value="representantes">Representantes</option>
                        <option value="cliente">Cliente</option>
                        <option value="colaborador">Colaborador</option>
                        <option value="supervisor">Supervisor</option>
                        <option value="todos">Todos</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1">
                    <div class="form-group">
                      <label for>Resumo</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="item.resumo"
                        @change="changeSomething()"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1-2">
                    <div class="form-group">
                      <label for>Dt Inicial</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="item.dtIni"
                        @change="changeSomething()"
                      />
                    </div>
                  </div>
                  <div class="col-1-2">
                    <div class="form-group">
                      <label for>Dt Final</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="item.dtFim"
                        @change="changeSomething()"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 80px">
                <div
                  class="pagebox"
                  @keyup="onKeyUp"
                  v-for="(i, index) in item.conteudo"
                >
                  <span
                    class="pagebox-up"
                    v-show="index !== 0"
                    v-on:click="invert(index - 1)"
                  >
                    <svg
                      style="fill: #9b9c9a; width: 24px; height: 24px"
                      x="0px"
                      y="0px"
                      viewBox="0 0 444.819 444.819"
                    >
                      <path
                        d="M433.968,278.657L248.387,92.79c-7.419-7.044-16.08-10.566-25.977-10.566c-10.088,0-18.652,3.521-25.697,10.566 L10.848,278.657C3.615,285.887,0,294.549,0,304.637c0,10.28,3.619,18.843,10.848,25.693l21.411,21.413 c6.854,7.23,15.42,10.852,25.697,10.852c10.278,0,18.842-3.621,25.697-10.852L222.41,213.271L361.168,351.74 c6.848,7.228,15.413,10.852,25.7,10.852c10.082,0,18.747-3.624,25.975-10.852l21.409-21.412 c7.043-7.043,10.567-15.608,10.567-25.693C444.819,294.545,441.205,285.884,433.968,278.657z"
                      ></path>
                    </svg>
                  </span>
                  <span
                    class="pagebox-down"
                    v-show="index !== item.conteudo.length - 1"
                    v-on:click="invert(index)"
                  >
                    <svg
                      style="fill: #9b9c9a; width: 24px; height: 24px"
                      x="0px"
                      y="0px"
                      viewBox="0 0 444.819 444.819"
                    >
                      <path
                        d="M434.252,114.203l-21.409-21.416c-7.419-7.04-16.084-10.561-25.975-10.561c-10.095,0-18.657,3.521-25.7,10.561 L222.41,231.549L83.653,92.791c-7.042-7.04-15.606-10.561-25.697-10.561c-9.896,0-18.559,3.521-25.979,10.561l-21.128,21.416 C3.615,121.436,0,130.099,0,140.188c0,10.277,3.619,18.842,10.848,25.693l185.864,185.865c6.855,7.23,15.416,10.848,25.697,10.848 c10.088,0,18.75-3.617,25.977-10.848l185.865-185.865c7.043-7.044,10.567-15.608,10.567-25.693 C444.819,130.287,441.295,121.629,434.252,114.203z"
                      ></path>
                    </svg>
                  </span>
                  <span v-on:click="remConteudo(index)" class="pagebox-remove">
                    <svg viewBox="0 0 21.9 21.9">
                      <path
                        d="M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0  c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4  s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3  s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7  s-0.1-0.5-0.3-0.7L14.1,11.3z"
                      ></path>
                    </svg>
                  </span>
                  <!-- txt -->
                  <div class="pagebox-txt" v-if="i.tipo === 'txt'">
                    <vue-editor
                      v-bind:id="'editor' + index"
                      :editorToolbar="customToolbar"
                      v-model="i.corpo"
                    ></vue-editor>
                  </div>
                  <!-- img -->
                  <div v-else-if="i.tipo === 'img'">
                    <label
                      class="button button-success button-lg"
                      v-if="i.corpo === ''"
                    >
                      <svg
                        style="
                          float: left;
                          margin-right: 12px;
                          width: 18px;
                          height: 18px;
                          fill: #fff;
                        "
                        x="0px"
                        y="0px"
                        viewBox="0 0 315.58 315.58"
                      >
                        <g>
                          <path
                            d="M310.58,33.331H5c-2.761,0-5,2.238-5,5v238.918c0,2.762,2.239,5,5,5h305.58c2.763,0,5-2.238,5-5V38.331 C315.58,35.569,313.343,33.331,310.58,33.331z M285.58,242.386l-68.766-71.214c-0.76-0.785-2.003-0.836-2.823-0.114l-47.695,41.979 l-60.962-75.061c-0.396-0.49-0.975-0.77-1.63-0.756c-0.631,0.013-1.22,0.316-1.597,0.822L30,234.797V63.331h255.58V242.386z"
                          ></path>
                          <path
                            d="M210.059,135.555c13.538,0,24.529-10.982,24.529-24.531c0-13.545-10.991-24.533-24.529-24.533 c-13.549,0-24.528,10.988-24.528,24.533C185.531,124.572,196.511,135.555,210.059,135.555z"
                          ></path>
                        </g>
                      </svg>
                      Selecione a Imagem
                      <input
                        type="file"
                        name="img"
                        style="display: none"
                        accept="image/jpg, image/jpeg, image/png, image/webp"
                        @change="handleUpload(index)"
                      />
                    </label>
                    <img :src="getImage(i.corpo)" v-else />
                  </div>
                  <!-- gal -->
                  <div v-else>
                    <div class="row" style="margin-bottom: 18px">
                      <label class="button button-success">
                        <svg
                          style="
                            float: left;
                            margin-right: 12px;
                            width: 18px;
                            height: 18px;
                            fill: #fff;
                          "
                          x="0px"
                          y="0px"
                          viewBox="0 0 315.58 315.58"
                        >
                          <g>
                            <path
                              d="M310.58,33.331H5c-2.761,0-5,2.238-5,5v238.918c0,2.762,2.239,5,5,5h305.58c2.763,0,5-2.238,5-5V38.331 C315.58,35.569,313.343,33.331,310.58,33.331z M285.58,242.386l-68.766-71.214c-0.76-0.785-2.003-0.836-2.823-0.114l-47.695,41.979 l-60.962-75.061c-0.396-0.49-0.975-0.77-1.63-0.756c-0.631,0.013-1.22,0.316-1.597,0.822L30,234.797V63.331h255.58V242.386z"
                            ></path>
                            <path
                              d="M210.059,135.555c13.538,0,24.529-10.982,24.529-24.531c0-13.545-10.991-24.533-24.529-24.533 c-13.549,0-24.528,10.988-24.528,24.533C185.531,124.572,196.511,135.555,210.059,135.555z"
                            ></path>
                          </g>
                        </svg>
                        Selecione a Imagem
                        <input
                          type="file"
                          name="img"
                          style="display: none"
                          accept="image/jpg, image/jpeg, image/png, image/webp"
                          @change="handleUploadGallery(index)"
                        />
                      </label>
                    </div>
                    <div class="row">
                      <div
                        class="col-1-3"
                        v-for="(x, indexImg) in i.corpo"
                        v-bind:key="indexImg"
                      >
                        <div class="thumbnail">
                          <div class="LogoimgBox">
                            <img :src="getImage(x)" />
                          </div>
                          <div class="caption">
                            <div class="caption__actions">
                              <button
                                v-on:click="removeImgGallery(index, indexImg)"
                                class="button button-sm button-error"
                              >
                                Remover
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pageboxadd">
                <span v-on:click="addConteudo('txt')" class="txt">
                  <svg
                    style="width: 12px; height: 12px; fill: #fff"
                    x="0px"
                    y="0px"
                    viewBox="0 0 42 42"
                  >
                    <path
                      d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                    ></path></svg
                  >Texto
                </span>
                <span v-on:click="addConteudo('img')" class="img">
                  <svg
                    style="width: 12px; height: 12px; fill: #fff"
                    x="0px"
                    y="0px"
                    viewBox="0 0 42 42"
                  >
                    <path
                      d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                    ></path>
                  </svg>
                  Imagem
                </span>
                <span v-on:click="addConteudo('gal')" class="gal">
                  <svg
                    style="width: 12px; height: 12px; fill: #fff"
                    x="0px"
                    y="0px"
                    viewBox="0 0 42 42"
                  >
                    <path
                      d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                    ></path>
                  </svg>
                  Galeria
                </span>
              </div>

              <div class="pageboxsave" v-show="shouldSave">
                <button
                  class="button button-success button-lg"
                  v-on:click="save()"
                >
                  Salvar Alterações
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, put, del, uploadImage } from "@/helpers/apiRequest";
import { customToolbar, getImage } from "@/helpers/utils";
const url = "/noticia";
/*
1) [   ] Dimensoes dinamicas
2) [ x ] Salvar os textos
3) [ x ] Reordenar
*/
export default {
  name: "paginas",
  props: ["id"],
  data() {
    return {
      customToolbar: customToolbar(),
      loading: false,
      shouldSave: false,
      item: {
        titulo: "",
        resumo: "",
        publico: "",
        img: [],
        conteudo: [],
      },
    };
  },
  methods: {
    getImage: getImage,
    invert(index) {
      let ini = this.item.conteudo.slice(0, index);
      let end = this.item.conteudo.slice(index + 2);
      let a = this.item.conteudo[index] || [];
      let b = this.item.conteudo[index + 1] || [];
      this.item.conteudo = [].concat(ini, b, a, end);
      this.shouldSave = true;
    },
    changeSomething() {
      this.shouldSave = true;
    },
    onKeyUp() {
      this.shouldSave = true;
    },
    save(withoutAlert) {
      console.log("withoutAlert", withoutAlert);
      this.loading = true;
      put(`${url}/${this.item._id}`, this.item)
        .then((json) => {
          this.loading = false;
          this.shouldSave = false;
          if (withoutAlert) {
            return;
          }
          this.$swal({ title: "Alterado com Sucesso!", type: "success" });
        })
        .catch((err) => console.log("err", err));
    },
    addConteudo(tipo) {
      this.item.conteudo.push({
        tipo,
        corpo: tipo === "gal" ? [] : "",
      });
      this.save({ withoutAlert: true });
    },
    remConteudo(index) {
      this.loading = true;
      del(`/noticias/conteudo/${this.item._id}/${index}`).then(() => {
        this.item.conteudo = this.item.conteudo.filter((_, k) => +k !== +index);
        this.loading = false;
      });
    },
    handleUpload(index) {
      event.preventDefault();
      const settings = {
        el: event.target,
        str: `/nested/noticias/conteudo/corpo/${this.item._id}/${index}`,
        dim: "400x400",
      };
      this.loading = true;
      uploadImage(settings)
        .then(({ filename }) => {
          this.item.conteudo = this.item.conteudo.map((i, k) => {
            if (+index === +k) {
              i.corpo = filename;
            }
            return i;
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeImg(index, cb) {
      this.loading = true;
      del(
        `/upload/nested/noticias/conteudo/corpo/${this.item._id}/${index}`
      ).then((json) => {
        this.item.conteudo = this.item.conteudo.map((i, k) => {
          if (+index === +k) {
            i.corpo = "";
          }
          return i;
        });
        this.loading = false;
        cb();
      });
    },
    handleUploadGallery(index) {
      event.preventDefault();
      const settings = {
        el: event.target,
        str: `/noticias/conteudo.${index}.corpo/${this.item._id}`,
        dim: "400x400",
      };
      this.loading = true;
      uploadImage(settings)
        .then(({ filename }) => {
          this.item.conteudo = this.item.conteudo.map((i, k) => {
            if (+index === +k) {
              i.corpo.push(filename);
            }
            return i;
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeImgGallery(index, indexImg) {
      this.loading = true;
      del(
        `/upload/noticias/conteudo.${index}.corpo/${this.item._id}/${indexImg}`
      ).then((json) => {
        this.item.conteudo = this.item.conteudo.map((i, k) => {
          if (+index === +k) {
            i.corpo = i.corpo.filter((_, kk) => +kk !== indexImg);
          }
          return i;
        });
        this.loading = false;
      });
    },
  },
  beforeMount() {
    this.loading = true;
    get(`${url}/${this.$route.params.id}`)
      .then((json) => {
        this.loading = false;
        this.item = json;
      })
      .catch((err) => console.log("err", err));
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Noticias/NoticiaSingle.vue